




























helpers = require('../../helpers.coffee')

view_model = {
  props:
    fetch_mode:
      default: "eligibleForANewFlow"
      validator: (value) ->
        fetch_modes = ["eligibleForANewFlow", "withoutGroup", "all"]
        fetch_modes.indexOf(value) > -1

    view_mode:
      default: null

    user_id:
      default: null

  data: ->
    contacts: []
    selected_contacts: {}
    persisted_contacts: {}
    fetching: false
    next_page: 1
    filters: {}

  computed:
    selected_contact_ids: ->
      Object.keys(@selected_contacts).map (id, index) ->
        parseInt(id)

  watch:
    user_id: (new_user_id) ->
      @clearData()
      @loadData()

  methods:
    clearData: ->
      @next_page = 1
      @fetching = false
      @filters = {}
      @contacts = []

    loadData: ->
      return if @fetching || !@next_page || @user_id == null
      @filters = @mergeCurrentUserFilter(@filters, @user_id)
      @fetching = true
      @fetchContacts()

    fetchContacts: ->
      filters = @filters
      filters.not_blocklisted_status = true
      params = {q: filters, page: @next_page}
      @selectFetchMode(params)

    selectFetchMode: (params) ->
      if(@fetch_mode == "eligibleForANewFlow")
        @contact_resource.eligibleForANewFlow @loadSuccess, @unknownError, params: params
      else if(@fetch_mode == "withoutGroup")
        @contact_resource.withoutGroup @loadSuccess, @unknownError, params: params
      else
        @contact_resource.index @loadSuccess, @unknownError, params: params

    loadSuccess: (resources) ->
      return if resources.contacts[0] && resources.contacts[0].user.id != @user_id
      @fetching = false
      @next_page = resources.meta.next_page
      @contacts = @contacts.concat(resources.contacts)

    filter: (filters) ->
      @contacts = []
      @filters = filters
      @next_page = 1
      @loadData()

    selectContacts: ->
      @$emit 'contacts-selected', { contacts: Object.values(@selected_contacts) }
      if @contacts.length == 0 && @next_page
        EventsBus.$emit 'ContactList:unSelectedAll'
        @loadData()

    updateContactSelection: (data) ->
      if data.attr.selected
        Vue.set @selected_contacts, data.attr.contact.id, data.attr.contact
      else
        Vue.delete @selected_contacts, data.attr.contact.id
      @selectContacts() if data.attr.force == true

    updatePersistedContacts: (data) ->
      @persisted_contacts = data.contacts
      @persisted_contacts.forEach (contact) =>
        @updateContactSelection { attr: { contact: contact, selected: true } }
      @selectContacts()

    getViewMode: ->
      if @view_mode then @view_mode else @contactListViewModes().picker

    addContact: (data) ->
      @contacts.unshift data.contact
      @updateContactSelection(attr: { contact: data.contact, selected: data.selected })
      @selectContacts()

    removeContact: (data) ->
      @contacts = @contacts.filter (contact) ->
        contact.id != data.id

  created: ->
    @contact_resource = new ContactsResource Session.current_company.id
    @loadData()

    EventsBus.$on 'ContactsPicker:SetPersistedSelectedContacts', @updatePersistedContacts
    EventsBus.$on 'ContactsPicker:RemoveContact', @removeContact
    EventsBus.$on 'ContactsPicker:AddContact', @addContact

  beforeDestroy: ->
    EventsBus.$off 'ContactsPicker:SetPersistedSelectedContacts', @updatePersistedContacts
    EventsBus.$off 'ContactsPicker:AddContact', @addContact
    EventsBus.$off 'ContactsPicker:RemoveContact', @removeContact
}

exports.default = helpers.vue_include(
  view_model, helpers.form,
  helpers.contacts.list_view_modes,
  helpers.filters
)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/picker.vue